import './android.css'
import android from '../../img/android.png'
export default function Android(){
    return(
        <div className='androidbox'>
            <div className='androidimage'><img src={android} alt='android' loading='lazy'></img></div>
            <div className='androiddownload'><a href='http://dl.mahoganyacademy.de/android/MAHOGANY_1_1.0.apk'>دانلود</a></div>
        </div>
    )
}